import React from 'react';

interface IProps {
	onIsIntersectingChange: (isIntersecting: boolean) => void;
	className?: string;
}

export const InViewInterceptor = ({ children, className, onIsIntersectingChange }: React.PropsWithChildren<IProps>) => {
	const target = React.useRef(null);

	React.useEffect(() => {
		const callback = (entries: IntersectionObserverEntry[]) => {
			const entry = entries[0];
			onIsIntersectingChange(entry.isIntersecting);
		};
		const observer = new IntersectionObserver(callback);
		if (target.current) {
			observer.observe(target.current);
		}

		return () => {
			if (observer) {
				observer.disconnect();
			}
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div ref={target} className={`${className ?? ''}`}>
			{children}
		</div>
	);
};
